import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  GlgPopup,
  GlgPopupForm,
  GlgSelect,
  GlgRadio,
} from '../../../../shared/components'

const internationalize = (...args) => !window.I18n ? '' : window.I18n.t(...args)

class SelectCustomField extends Component {
  constructor(props){
    super(props)
    this.state = {
      metadatumId: props.metadatumId || null,
      metadatumAnswer: props.metadatumAnswer || null,
      errors: null,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.metadatumId !== this.props.metadatumId || prevProps.metadatumAnswer !== this.props.metadatumAnswer) {
      this.setState({
        metadatumId: this.props.metadatumId || null,
        metadatumAnswer: this.props.metadatumAnswer || null,
        errors: null,
      })
    }
  }

  render() {
    const handleSave = () => {
      if (!this.state.metadatumId || !this.state.metadatumAnswer) {
        this.setState({ errors: internationalize('divisions.index.by_multiple_criteria.required_answer') })
        return
      }
        
      this.props.fetchAndUpdateDivision(this.props.divisionId, {
        metadatumAnswer: this.state.metadatumAnswer, 
        metadatumId: this.state.metadatumId,
      })
      this.props.onClose()
    }
  
    const handleClose = () => {
      this.setState({
        metadatumId: this.props.metadatumId || null,
        metadatumAnswer: this.props.metadatumAnswer || null,
        errors: null,
      })
    
      this.props.onClose()
    }

    return (
      <GlgPopup 
        id='select-custom-field-popup'
        show={this.props.showModal}
        title={internationalize('divisions.index.by_multiple_criteria.popup.select_custom_field')}
        onClose={handleClose}
        manualClose={true}
        onSave={handleSave}
        modalClass='dashboard_widget_modal select_custom_field_popup'
        closeButtonText={ internationalize('reports.print_options_divisions.cancel') }>
        <GlgPopupForm className='white_background select_custom_field_body' id='select-custom-field-form'>
          <div>
            <label className='custom_field_label'>{ internationalize('divisions.index.by_multiple_criteria.custom_field') }</label>
            <GlgSelect
              key='select_custom_field'
              items={this.props.customFields.choices}
              placeholder={internationalize('divisions.index.by_multiple_criteria.popup.please_select')}
              value={this.state.metadatumId}
              noPreFill={true}
              usePortal={true}
              onChange={(value) => this.setState({ metadatumId: value, metadatumAnswer: null, errors: null })}
            />
            {
              this.props.customFieldAnswers[this.state.metadatumId] &&
              <label className='select_option_label'>{ internationalize('divisions.index.by_multiple_criteria.popup.select_option') }</label>
            }
            <div className='custom_field_answers'>
            {
              this.props.customFieldAnswers[this.state.metadatumId]?.answers?.map((answer) =>
                answer &&
                <GlgRadio
                  key={`select_custom_field_${answer}`}
                  name={'select_custom_field_answer'}
                  value={answer}
                  label={answer}
                  checked={ answer === this.state.metadatumAnswer }
                  onChange={(value) => 
                    this.setState((prevState) => ({
                      ...prevState,
                      metadatumAnswer: value,
                      errors: null,
                    }))
                  }
                />,
              )
            }
            </div>
          </div>
        </GlgPopupForm>
        {this.state.errors && <div className='error_message'>{this.state.errors}</div>}
      </GlgPopup>
    )
  }
}

SelectCustomField.propTypes = {
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  customFields: PropTypes.object,
  customFieldAnswers: PropTypes.object,
  divisionId: PropTypes.number,
  metadatumId: PropTypes.string,
  metadatumAnswer: PropTypes.string,
  fetchAndUpdateDivision: PropTypes.func,
}


SelectCustomField.defaultProps = {
  showModal: false,
}

export default SelectCustomField
